(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("karmadataUI", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["karmadataUI"] = factory(require("react"), require("react-dom"));
	else
		root["karmadataUI"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_123__, __WEBPACK_EXTERNAL_MODULE_174__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition